import { Security } from './Security';

const Sec0 = require('../proto/sec0_pb');
const Session = require('../proto/session_pb');

/**
 * Security 0 implementation of the handshake and encryption
 * protocol.
 * Security 0 specifies no encryption and only a single step handshake.
 */
export class Security0 implements Security {
    private static readonly SESSION_STATE_0 = 0;
    private static readonly SESSION_STATE_1 = 1;

    private sessionState = Security0.SESSION_STATE_0;

    public getNextRequestInSession(
        hexData?: Uint8Array
    ): Uint8Array | undefined {
        let response: Uint8Array | undefined;

        switch (this.sessionState) {
            case Security0.SESSION_STATE_0:
                this.sessionState = Security0.SESSION_STATE_1;
                response = this.getStep0Request();
                break;
            case Security0.SESSION_STATE_1:
                this.processStep0Response(hexData);
                break;
        }

        return response;
    }

    public encrypt(data: Uint8Array): Uint8Array {
        return data;
    }

    public decrypt(data: Uint8Array): Uint8Array {
        return data;
    }

    private getStep0Request(): Uint8Array | undefined {
        const s0SessionCmd = new Sec0.S0SessionCmd();
        const sec0Payload = new Sec0.Sec0Payload();
        sec0Payload.setSc(s0SessionCmd);
        const newSessionData = new Session.SessionData();
        newSessionData.setSecVerValue(0);
        newSessionData.setSec0(sec0Payload);

        return newSessionData.serializeBinary();
    }

    private processStep0Response(hexData?: Uint8Array): void {
        try {
            if (!hexData) {
                throw new Error('No response from device');
            }

            const responseData =
                Session.SessionData.deserializeBinary(hexData);

            if (
                responseData.getSecVer() !==
                Session.SecSchemeVersion.SECSCHEME0
            ) {
                throw new Error('Security version mismatch');
            }
        } catch (e) {
            console.error(e);
        }
    }
}
